import React from "react"

import { ONE_WAY_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import AcrissGroupsContent from "./Content"


export default function AcrissGroupsPage() {
	return <PageWrapper
		head={`DS Rentacar | ${ONE_WAY_ROUTES.ACRISS_GROUPS_TITLE}`}
		title={ONE_WAY_ROUTES.TITLE}
		subtitle={ONE_WAY_ROUTES.ACRISS_GROUPS_TITLE}
		isEmpty={false}
	>
		<AcrissGroupsContent />
	</PageWrapper>
}
